const REACTION_ICON_SIZES = {
  TINY: 17,
  SMALL: 20,
  MEDIUM: 22,
  BIG: 24,
  LARGE: 30
};

const REACTION_NAMES = {
  'thumbs-up': {
    www: 'Нравится',
    kaz: 'Ұнайды'
  },
  'red-heart': {
    www: 'В восторге',
    kaz: 'Тамаша'
  },
  'grinning-face-with-smiling-eyes': {
    www: 'Смешно',
    kaz: 'Күлкілі'
  },
  'face-with-open-mouth': {
    www: 'Удивлён',
    kaz: 'Таңғалдым'
  },
  'crying-face': {
    www: 'Грустно',
    kaz: 'Өкінішті'
  },
  'enraged-face': {
    www: 'Злой',
    kaz: 'Ашулымын'
  }
};

const AVAILABLE_REACTION_LIST = Object.keys(REACTION_NAMES);
const REACTION_THUMBS_UP = 'thumbs-up';

const permanentReaction = {
  type: REACTION_THUMBS_UP,
  count: 0,
  updatedAt: new Date().toISOString()
};

export {
  REACTION_ICON_SIZES,
  REACTION_NAMES,
  AVAILABLE_REACTION_LIST,
  REACTION_THUMBS_UP,
  permanentReaction
};
